import { View } from "extensions/marionette";
import { Backbone } from "extensions/backbone";

import { CategoriesList } from "./categoriesList";
import allFiltersTemplate from "./allFilters.jst";

export const AllFilters = View.extend({
    className: "all-filters",
    template: allFiltersTemplate,
    events: {
        "click .quick": function() {
            this.toggleMode({
                multi: false
            });
        },
        "click .multi": function() {
            this.toggleMode({
                multi: true
            });
        }
    },
    ui: {
        quick: ".quick",
        multi: ".multi"
    },
    regions: {
        categories: {
            el: ".categories",
            replaceElement: true
        }
    },
    childViewEvents: {
        "clicked:item": "handleCategoryClick",
        "treeitem:selected": "setFilter"
    },
    
    initialize() {
        this.state = {
            multi: true
        };
    },
    
    setFilter(model, operator) {
        this.triggerMethod("add:filter", {
            model,
            operator,
            state: this.state
        });
    },
    
    toggleMode({ multi, silent = false } = {}) {
        // Save state on the view
        this.state.multi = multi;
        
        this.ui.quick.toggleClass("btn-light-blue", !multi).toggleClass("btn-white", multi);
        this.ui.multi.toggleClass("btn-light-blue", multi).toggleClass("btn-white", !multi);
        
        // If not longer in multi view trigger an event to clean up unapplied filters
        if (!multi && !silent) {
            this.triggerMethod("clear:temp:filters");
        }
    },
    
    getCategoriesData() {
        return Object.entries(this.getOption("parent").allLabels).map(([pivot, items]) => ({
            ref: pivot,
            alias: items[0].typeString, // TODO: think about better way to pass an alias for the category
            items: new Backbone.Collection(items.filter(({ name, value }) => name && value))
        }));
    },
    
    onRender() {
        // Set initial button state
        this.toggleMode({
            multi: false,
            silent: true
        });
        
        // Render all categories
        this.showChildView("categories", new CategoriesList({
            collection: new Backbone.Collection(this.getCategoriesData()),
            parent: this.getOption("parent")
        }));
    }
});
